import { PowerUserMenu } from "domains/settings/containers/PowerUserMenu";
import { useAtom } from "jotai";
import type { BaseLayoutSlots } from "layouts/BaseLayout";
import { ModeSwitcher } from "layouts/ModeSwitcher";
import { SidebarNavigation } from "layouts/SidebarNavigation";
import { powerUserMenuAtom } from "services/powerUser";
import { useShiftsNavItems } from "./useShiftsNavItems";
import { useShowHireSwitch } from "./useShowHireSwitch";

type ShiftsSidebarNavContainerProps = {
  title: string;
  hideDefaultHeader?: boolean;
  slots?: Pick<BaseLayoutSlots, "topNavigation" | "mobileHeader">;
};

export function ShiftsSidebarNavContainer({
  title,
  hideDefaultHeader,
  slots,
}: Readonly<ShiftsSidebarNavContainerProps>) {
  const [powerUserMenuOpen, setPowerUserMenuOpen] = useAtom(powerUserMenuAtom);
  const navItems = useShiftsNavItems();
  const showHireSwitch = useShowHireSwitch();

  return (
    <>
      <SidebarNavigation
        title={title}
        hideDefaultHeader={hideDefaultHeader}
        slots={slots}
        navItems={navItems}
        modeSwitcher={showHireSwitch && <ModeSwitcher currentMode="shifts" />}
      />
      <PowerUserMenu open={powerUserMenuOpen} onOpenChange={setPowerUserMenuOpen} />
    </>
  );
}
